
export default {
  data() {
    return {
      logo_path: require('@/assets/logo/original_logo.jpg'),
    }
  },
}
